import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;
export const Team = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Shield = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
`;
export const Name = styled.span`
  font-size: 13px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  margin-top: 20px;
`;
export const Score = styled.div`
  display: flex;
  align-items: center;
`;
export const ScoreNumber = styled.span`
  font-size: 43px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  margin: 10px;
  line-height: 50px;
`;
export const ScoreLine = styled.span`
  height: 2px;
  width: 10px;
  background-color: ${({ theme }) => theme.coral};
  display: inline-block;
`;
